import React from 'react';
import { Table, Tag, Badge } from 'antd';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { OrderStatus } from '../../../../util/helper';

const OrdersTable = ({ orders, loading }) => {
  const brokersList = useSelector((state) => state?.brokers?.list || []);
  const getBrokerLabel = (id) => {
    const b = (brokersList || []).find(x => (x?.id?.toString?.() || '') === id?.toString?.());
    if (!b) return id;
    return b?.name?.toUpperCase() || `${b?.type?.toUpperCase?.()} - ${b?.userName?.toUpperCase?.()}` || id;
  };
  const getOrderStatusColor = (status) => {
    const statusMap = {
      'Pending': 'processing',
      'Completed': 'success',
      'Failed': 'error',
      'Cancelled': 'default',
      'Rejected': 'error',
    };
    return statusMap[status] || 'default';
  };

  const orderColumns = [
    {
      title: 'Symbol',
      dataIndex: ['instrument', 'tradingSymbol'],
      align: 'left',
      key: 'symbol',
      width: '20%',
      ellipsis: true,
    },
    {
      title: 'Product',
      dataIndex: 'product',
      key: 'product',
      width: '8%',
      align: 'center',
      render: (product) => (
        <p style={{ fontSize: 12 }} className='product-text'>{product}</p>
      ),
    },
    {
      title: 'Order Type',
      dataIndex: 'orderType',
      key: 'orderType',
      width: '10%',
      align: 'center',
      render: (orderType) => (
        <span className='orderType'>{orderType}</span>
      ),
    },
    {
      title: 'Broker',
      dataIndex: 'brokerId',
      key: 'broker',
      width: '20%',
      align: 'center',
      render: (brokerId) => (
        <Tag color="purple">{getBrokerLabel(brokerId)}</Tag>
      ),
    },
    {
      title: 'Type',
      dataIndex: 'transactionType',
      key: 'type',
      width: '10%',
      align: 'center',
      render: (type) => (
        <Badge 
          color={type === 'BUY' ? 'green' : 'red'} 
          text={type} 
        />
      ),
    },
    {
      title: 'Qty',
      dataIndex: 'quantity',
      key: 'quantity',
      width: '10%',
      align: 'right',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      key: 'price',
      width: '15%',
      align: 'center',
      render: (price) => price ? Number(price).toFixed(2) : 'Market',
    },
    {
      title: 'Status',
      dataIndex: 'internalStatus',
      key: 'status',
      width: '15%',
      align: 'center',
      render: (internalStatus) => {
        const status = OrderStatus(internalStatus);
        return (
          <Badge 
            status={getOrderStatusColor(status)} 
            text={status} 
          />
        );
      }
    },
    {
      title: 'Order Id',
      dataIndex: 'orderId',
      key: 'orderId',
      width: '15%',
      align: 'center',
      render: (orderId) => orderId,
    },
    {
      title: 'Received At',
      dataIndex: 'receivedAt',
      key: 'receivedAt',
      width: '15%',
      align: 'center',
      render: (receivedAt) => receivedAt ? moment(receivedAt).format('HH:mm:ss') : '-',
    },
    {
      title: 'Order Time',
      dataIndex: 'orderTime',
      key: 'orderTime',
      width: '10%',
      align: 'center',
      render: (timestamp) => timestamp ? moment(timestamp).format('HH:mm:ss') : '-',
    },
  ];

  return (
    <div style={{ width: '80vw', overflow: 'hidden' }}>
      <Table
        columns={orderColumns}
        dataSource={orders}
        rowKey="id"
        loading={loading}
        pagination={false}
        size="small"
        scroll={{ x: true }}
        locale={{ emptyText: 'No orders found' }}
        style={{ width: '100%' }}
        tableLayout="fixed"
      />
    </div>
  );
};

export default OrdersTable;
